@let cnf = config()?.config;
@if (cnf) {
  <div class="header-container" #headerContainer>
    @if (cnf.logoFileId) {
      <tm-image-with-description [src]="getUrl(cnf.logoFileId)" (load)="checkUseDropdown()" class="header-logo-image"></tm-image-with-description>
    }
    <h1 class="header-title">{{cnf.title}}</h1>
    @if (cnf.menuItems) {
      <div class="header-menu" #headerMenu>
        @if (!useDropdownMenu()) {
          @for (item of cnf.menuItems; track $index) {
            <a [href]="item.url" class="header-menu-item" target="_blank" rel="noopener noreferrer">
              {{item.label}}
            </a>
          }
        } @else {
          <button mat-icon-button [matMenuTriggerFor]="dropdownMenu" class="overflow-menu-button">
            <mat-icon svgIcon="menu"></mat-icon>
          </button>
          <mat-menu #dropdownMenu="matMenu">
            @for (item of cnf.menuItems; track $index) {
              <a class="dropdown-menu-item" mat-menu-item [href]="item.url" target="_blank" rel="noopener noreferrer">
                {{item.label}}
              </a>
            }
          </mat-menu>
        }
      </div>

      <!-- Hidden measurement container with proper scoped styles -->
      <div class="header-menu measurement-container" #measurementContainer>
        @for (item of config()?.config?.menuItems || []; track $index) {
          <a class="header-menu-item">{{item.label}}</a>
        }
      </div>
    }
  </div>
}
